import { PaymentMethod } from "@freightsimple/generated-dashboard-openapi-client/models/PaymentMethod";
import type { PaymentMethodsState } from "../Types/paymentsPaymentTypes";

export const paymentsResolvePaymentMethodText = (
  selectedPaymentMethod: string | undefined,
  paymentMethodsState: PaymentMethodsState,
) => {
  if (!selectedPaymentMethod) return undefined;

  const isBankAccount = paymentMethodsState.bankAccounts.some(
    (ba) => ba.stripePaymentMethodId === selectedPaymentMethod,
  );

  if (isBankAccount) {
    return PaymentMethod.BankAccount;
  }

  const isCreditCard = paymentMethodsState.creditCards.some(
    (cc) => cc.stripePaymentMethodId === selectedPaymentMethod,
  );

  if (isCreditCard) {
    return PaymentMethod.CreditCard;
  }
  switch (selectedPaymentMethod) {
    case "cheque":
      return PaymentMethod.Cheque;
    case "etransfer":
      return PaymentMethod.InteracETransfer;
    case "eft":
      return PaymentMethod.Eft;
    case "wire":
      return PaymentMethod.Wire;
    case "cash":
      return PaymentMethod.Cash;
    default:
      return undefined;
  }
};
